import { render } from "./CkeditorModule.vue?vue&type=template&id=568e5a1c&scoped=true"
import script from "./CkeditorModule.vue?vue&type=script&lang=ts"
export * from "./CkeditorModule.vue?vue&type=script&lang=ts"

import "./CkeditorModule.vue?vue&type=style&index=0&id=568e5a1c&lang=css"
import "./CkeditorModule.vue?vue&type=style&index=1&id=568e5a1c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-568e5a1c"

export default script